// style-utils.js
import { css } from 'styled-components';
import accounting from 'accounting';
import getSymbolFromCurrency from 'currency-symbol-map';

export const renderMoney = (value, currencyCode) => {
  return accounting.formatMoney(value, {
    symbol: getSymbolFromCurrency(currencyCode),
    format: '%s %v',
    precision: 4,
  });
};

export const calculateCurrencyRate = currencyAmount => {
  if (!currencyAmount) return 0;
  return fx(currencyAmount)
    .from('USD')
    .to(this.state.selectedFiatCurrency);
};
